(() => {
  const key = 'wild-rose-music-v1';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-wr-music]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const audio = root.querySelector('audio');
      const toggle = root.querySelector('.wr-music-toggle');
      const status = root.querySelector('.wr-music-status');
      const tr = root.dataset.language === 'tr';
      let saved = {};
      try { saved = JSON.parse(sessionStorage.getItem(key)) || {}; } catch (_) { /* Storage is optional. */ }
      const volume = Math.min(.20, Math.max(.02, Number(root.dataset.volume) / 100 || .04));
      let wanted = saved.enabled !== false;
      let context, gain, source, disposed = false;
      const update = () => {
        const playing = !audio.paused;
        toggle.setAttribute('aria-pressed', String(playing));
        toggle.setAttribute('aria-label', tr ? (playing ? 'Sessize al' : 'Sesi aç') : (playing ? 'Mute sound' : 'Turn sound on'));
        toggle.title = toggle.getAttribute('aria-label');
      };
      const save = () => {
        try { sessionStorage.setItem(key, JSON.stringify({enabled: wanted, volume, time: audio.currentTime, src: audio.getAttribute('src')})); } catch (_) { /* Private browsing remains usable. */ }
      };
      const applyVolume = () => {
        if (gain) { gain.gain.setTargetAtTime(volume, context.currentTime, .08); audio.volume = 1; }
        else audio.volume = volume;
      };
      // Web Audio gain also keeps volume low on iPhones that ignore audio.volume.
      const prepare = () => {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!context && AudioContext) {
          try {
            context = new AudioContext();
            source = context.createMediaElementSource(audio);
            gain = context.createGain();
            gain.gain.value = volume;
            source.connect(gain).connect(context.destination);
          } catch (_) { context = null; gain = null; }
        }
        applyVolume();
        return context ? context.resume() : Promise.resolve();
      };
      const play = async () => {
        wanted = true;
        status.textContent = '';
        try { if (disposed) return; await Promise.all([prepare(), audio.play()]); }
        catch (_) {
          status.textContent = tr ? 'Müziği başlatmak için ses düğmesine dokunun.' : 'Tap the sound button to start music.';
        }
        update(); save();
      };
      toggle.addEventListener('click', () => {
        if (audio.paused) void play();
        else { wanted = false; audio.pause(); update(); save(); }
      });
      const enterWithMusic = () => { if (!disposed && wanted) void play(); };
      document.addEventListener('wild-rose:music-start', enterWithMusic);
      // Retry blocked autoplay after a real interaction, without overriding mute.
      const retry = event => {
        if (!wanted || disposed || root.contains(event.target) || !audio.paused) return;
        void play();
      };
      document.addEventListener('pointerup', retry);
      document.addEventListener('keydown', retry);
      audio.addEventListener('loadedmetadata', () => {
        if (saved.src === audio.getAttribute('src') && Number.isFinite(saved.time) && audio.duration > 0) audio.currentTime = saved.time % audio.duration;
      }, {once: true});
      audio.addEventListener('play', update);
      audio.addEventListener('pause', update);
      audio.addEventListener('timeupdate', save);
      audio.addEventListener('error', () => {
        wanted = false; audio.pause(); update(); save();
        status.textContent = tr ? 'Müzik yüklenemedi. Daha sonra tekrar deneyin.' : 'Music could not load. Try again later.';
      });
      const dispose = () => { save(); disposed = true; audio.pause(); if (context) void context.close(); document.removeEventListener('wild-rose:music-start', enterWithMusic); document.removeEventListener('pointerup', retry); document.removeEventListener('keydown', retry); window.removeEventListener('pagehide', dispose); };
      window.addEventListener('pagehide', dispose);
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', dispose, {once:true});
      applyVolume(); update();
      if (wanted) void play();
    });
  };
  init();
  if (!window.wildRoseMusicBound) {
    window.wildRoseMusicBound = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();

